import React from 'react';
import {
    Stack,
    Card,
    CardContent,
    Typography,
    Pagination,
    Box,
    Button,
    Collapse, 
    IconButton,
} from '@mui/material';
import {
    CheckCircle as CheckCircleIcon,
    Error as ErrorIcon,
    Pending as PendingIcon,
    EvStation as EvStationIcon,
    DirectionsCar as DirectionsCarIcon,
} from '@mui/icons-material';
import SessionsChartSmall from './SessionsChartSmall';
import { CarPieChart, CarBarChart, Battery } from './CarCharts';
import { BatteryHealth, HistogramChart } from './BatteryHealth';

import { cloneDatetTime, formatFullHour, getDatetime, isDate } from '../utils/datetimeUtils';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

function capitalize(text) {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export default function PagedCarsVehicle({ carData = [], itemsPerPage = 12, evstatus = {},  piedata = {}, detailsdata = {} }) {

    const [expandedCard, setExpandedCard] = React.useState(null); 
    const toggleExpand = (index) => { 
        setExpandedCard((prev) => (prev === index ? null : index));
    };

    console.log("details.data >>>");
    console.log(detailsdata);
    console.log("details.data done >>>");

     const handlePrintVehicle = (vin) => {
        // const element = document.getElementById(`vehicle-data-card-${vin}`);
        const element2 = document.getElementById(`vehicle-piechart-${vin}`);
        const element3 = document.getElementById(`vehicle-histogram-${vin}`);

        if ( !element2 && !element3) return;

        const now = new Date();
        const timeString = now.toLocaleTimeString();
        const dateString = now.toLocaleDateString();  // e.g., 8/13/2025


        const printWindow = window.open('', '', 'height=600,width=800');
        printWindow.document.write('<html><head><title>Print Vehicle</title>');

        // Inline styles for print view (can be expanded to match MUI)
        printWindow.document.write(`
            <style>
                body { font-family: Arial, sans-serif; padding: 20px; }
                .card-print { width: 100%; box-shadow: none; border: 1px solid #ccc; }
            </style>
        `);

        printWindow.document.write('  <script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"></script>');

        printWindow.document.write('</head><body>');
        printWindow.document.write(
           `<h1 style="text-align:center;"> Battery Health Certificate</h1> <h5 style="text-align:center;">${dateString}  ${timeString}</h5>`
        );
        printWindow.document.write('<div id="qrcode" style="float:right";></div><script>new QRCode(document.getElementById("qrcode"),{text:"https://vgi.natcsv.com/dashboard/vehicle-dashboard",width:128,height:128,colorDark:"#000000",colorLight:"#ffffff",correctLevel:QRCode.CorrectLevel.H});</script>');


        printWindow.document.write(`
        <div class="vehicle-info">
            <h3>Vehicle Details</h3>
            <table>
                <tr><td><strong>VIN</strong></td><td>${vin}</td></tr>
                <tr><td><strong>Model</strong></td><td>${String(detailsdata?.[vin]?.vehicle?.brand)}</td></tr>
                <tr><td><strong>Range</strong></td><td>${parseInt(detailsdata?.[vin]?.chargeState.range)}</td></tr>
                <tr><td><strong>Odometer</strong></td><td>${parseInt(detailsdata?.[vin]?.odometer)}</td></tr>
            </table>
        </div>
        `);

        printWindow.document.write(
           ' <br/><h3 align: center> Battery State of Health</h1> '
        );
        printWindow.document.write(element3.outerHTML);
        printWindow.document.write(
           ' <br/><h3 align: center> Battery History</h1> '
        );
        printWindow.document.write(element2.outerHTML);



        printWindow.document.write('</body></html>');

        printWindow.document.close();
        printWindow.print();
    };




        const sohBins = [
            { label: 'Excellent (>94.5%)', min: 94.565, max: Infinity, count: 6 },
            { label: 'Very Good (93.4-94.5%)', min: 93.391, max: 94.565, count: 13 },
            { label: 'Good (92.2-93.4%)', min: 92.216, max: 93.391, count: 16 },
            { label: 'Fair (91.0-92.2%)', min: 91.042, max: 92.216, count: 21 },
            { label: 'Moderate (89.9-91.0%)', min: 89.867, max: 91.042, count: 14 },
            { label: 'Slightly Worn (88.7-89.9%)', min: 88.692, max: 89.867, count: 14 },
            { label: 'Worn (87.5-88.7%)', min: 87.518, max: 88.692, count: 15 },
            { label: 'Old (86.3-87.5%)', min: 86.343, max: 87.518, count: 8 },
            { label: 'Very Old (85.2-86.3%)', min: 85.168, max: 86.343, count: 11 },
            { label: 'Critical (84-85.2%)', min: 83.994, max: 85.168, count: 5 }
        ];

    const histogram1 = sohBins.map(bin => bin.count);
    // const labels = sohBins.map(bin => bin.label);

    const sohArray = [
        { vin: 'JN1DF0BB0PM711072', soh: 99.98 , capacity: 87},
        { vin: '1N4AZ1CP9KC302872', soh: 90.95, capacity: 87 },
        { vin: '1N4AZ1BV7NC564247', soh: 95.54, capacity: 87 },
        { vin: '1N4AZ1BV8NC563690', soh: 94.94, capacity: 87 },
        { vin: '1N4AZ1BVXNC560239', soh: 97.6, capacity: 87 },
        { vin: '1N4CZ1CV1RC554732', soh: 97.98, capacity: 60 },
        { vin: '1N4CZ1CV2RC554819', soh: 96.86, capacity: 87 },
        { vin: 'JN1AZ0CP9BT002191', soh: 94.80, capacity: 87 },
        { vin: '7FCTGAAA2NN005839', soh: 89.80, capacity: 87 },
    
    ];


    const getSOHByVIN = (vin) => {
        const car = sohArray.find(c => c.vin === vin);
        return car ? car.soh : null; // or undefined if not found
    };

     const getBinIndexBySohAndVin = (vin) => {
    // function getBinIndexBySohAndVin(vin) {
        const soh_val = getSOHByVIN(vin);
        return sohBins.findIndex(bin => soh_val > bin.min && soh_val <= bin.max);
    }


    const getCapacityByVIN = (vin) => {
        const car = sohArray.find(c => c.vin === vin);
        return car ? car.capacity : null; // or undefined if not found
    };

    const getWearCategoryByVIN = (vin) => {
        const binIndex = getBinIndexBySohAndVin(vin);
        if (binIndex === -1) return "unknown";

        if (binIndex >= 0 && binIndex <= 3) {
            return "Less wear";
        } else if (binIndex >= 4 && binIndex <= 6) {
            return "Normal wear";
        } else if (binIndex >= 7 && binIndex <= 9) {
            return "High wear";
        }
        return "unknown";
    };

    console.log(" paged cars vehicle evstatus")
    console.log(evstatus);
    console.log("paged cars vehicle piedata")
    console.log(piedata);
    console.log("car data");
    console.log(carData);

    const [page, setPage] = React.useState(1);
    if (carData === null) {
        return (
            <Typography variant="h6" align="center" color="text.secondary" mt={4}>
                No Car is connected.
            </Typography>
        );
    }

    const handleChange = (event, value) => {
        setPage(value);
    };

    const startIdx = (page - 1) * itemsPerPage;
    const endIdx = startIdx + itemsPerPage;
    // console.log("here");
    // console.log(carData);
    const carsToShow = carData.filter(d => {
        if (!!d.prediction?.arrival_time_pst) {
            return true;
        }
        return false;
    }).slice(startIdx, endIdx);


    const getPlugStateName = (status) => {        
        return status || 'N/A';
    };

    const getTimeFormat = (d) => {
        if (d === undefined || d === null) {
            return 'null'
        }
        if (!isDate(d)) {
            d = getDatetime(d);
        }
        // const pstDate = new Date(d.getTime() + 8 * 60 * 60 * 1000);
        return d.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        })
    }



    if (carData.length === 0) {
        return (
            <Typography variant="h6" align="center" color="text.secondary" mt={4}>
                no plugged in car.
            </Typography>
        );
    }
    const INDEX_MINUTES_DIFF = 10;
    const MAX_MINUTES_ON_MAP = 60 * 24;
    const getNextMinutes = (dateStr, index) => {
        const tempDate = cloneDatetTime(getDatetime(dateStr)); //isPst ? new Date(dateStr?.getTime?.() || dateStr) :  getPstTime(dateStr);
        tempDate.setMinutes(tempDate.getMinutes() + (INDEX_MINUTES_DIFF * index));
        return tempDate;
    }

    for (const car of carsToShow) {
        const arrivalTime = car.optimization?.arrival_time_pst;
        car.evstatus = evstatus?.[car?.VIN] || {};
        car.piedata = piedata?.[car?.VIN] || {};
        car.detailsdata = detailsdata?.[car?.VIN] || {};

        if (arrivalTime) {
            car.arrivalTime = getDatetime(arrivalTime);
            const createdAt = getDatetime(car?.prediction?.created_at);
            const tempArrivalTime = getDatetime(createdAt);
            car.predictionCard = {
                title: 'Depart PDF',
                showHeader: false,
                value: ``,
                interval: `Prediction time`,
                trend: 'up',
                data: car?.prediction?.pdf?.map((d, index) => ({ label: getNextMinutes(tempArrivalTime, index), value: d.toFixed(3) }))
                    .filter(d => d.label.getTime() >= createdAt.getTime()) || []
            };
            car.optimizationCard = {
                title: 'Charge Schedule',
                showHeader: false,
                value: ``,
                interval: `Optimization time`,
                trend: 'up',
                data: car?.optimization?.p_ev_charge?.map((d, index) => ({ label: getNextMinutes(tempArrivalTime, index), value: Math.abs(d || 0).toFixed(2) })) || []
            };

            car.socCard = {
                title: 'SOC',
                showHeader: false,
                value: ``,
                interval: `State of charge`,
                trend: 'up',
                data: car?.optimization?.soc?.map((d, index) => ({ label: getNextMinutes(tempArrivalTime, index), value: parseInt(((d || 0) * 100).toFixed(1)) })) || []
            };

            const cutoffIndex = MAX_MINUTES_ON_MAP / INDEX_MINUTES_DIFF;
            car.optimizationCard.data = car.optimizationCard.data.slice(0, cutoffIndex + 1);
            car.predictionCard.data = car.predictionCard.data.slice(0, cutoffIndex + 1);
            car.socCard.data = car.socCard.data.slice(0, cutoffIndex + 1);

            let maxOptimization = 0;

            for (let i = 0; i < car?.optimization?.p_ev_charge?.length; i++) {
                const curOptimization = car?.optimization.p_ev_charge[i];
                if (curOptimization > maxOptimization) {
                    maxOptimization = curOptimization;
                }
            }
            car.peakTime = getDatetime(car?.optimization?.departure_time);
            car.maxOptimization = maxOptimization;
        }

        // console.log("here data test");
        // console.log(detailsdata?.[car.VIN]?.chargeState.isCharging);
        
    }


return (
  <Box sx={{ padding: 1 }}>
    <Stack spacing={2}>
      {carsToShow.map((car, idx) => (
        <Card
          key={startIdx + idx}
          variant="outlined"
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            padding: 1,
            borderRadius: 2,
            boxShadow: 2,
            transition: 'transform 0.3s',
            '&:hover': {
              transform: 'scale(1.03)',
              boxShadow: 4,
            },
          }}
        >
          <CardContent className="vehicle-card">
            {/* Header */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, ml:2 }}>
              <DirectionsCarIcon color="primary" />
              <EvStationIcon color="secondary" />
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {car.name || detailsdata?.[car.VIN]?.vehicle?.model || 'Vehicle details'}
              </Typography>
            </Box>

            {/* Always visible info */}
                          {/* <Box sx={{ display: 'flex', gap: 4, mt: 3, flexWrap: 'wrap' }}> */}
            {/* <Box sx={{ display: 'flex', justifyContent: 'space-between',flexWrap: 'wrap', width: '100%', mb: 2, ml:2 }}> */}
           

            <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(6, 1fr)', // 6 equal columns
                width: '100%',
                gap: 2,
                mb: 2,
                ml:2,
                '@media (max-width:1200px)': { gridTemplateColumns: 'repeat(3, 1fr)' },
                '@media (max-width:800px)': { gridTemplateColumns: 'repeat(2, 1fr)' },
                '@media (max-width:500px)': { gridTemplateColumns: 'repeat(1, 1fr)' },
            }}
            >

            {/* <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap', mb: 2 }}> */}
              <DataItem label="VIN" value={car.VIN} />
              <DataItem label="Brand" 
                value={
                        detailsdata?.[car.VIN]?.vehicle?.brand != null
                        ? `${String(detailsdata?.[car.VIN]?.vehicle?.brand)} `
                        : '-'
                } />

              <DataItem label="Arrival Time" value={formatFullHour(car.arrivalTime)} />
              <DataItem label="Departure Time" value={formatFullHour(car.peakTime)} />

              <DataItem
                label="SoC"
                value={`${parseInt(evstatus?.[car.VIN]?.currentSoc || 0)} %`}
              />
              {/* <DataItem
                label="Charging"
                value={detailsdata?.[car.VIN]?.chargeState.isCharging ? 'True' : 'False'}
              /> */}
              <DataItem
                    label="Updated On"
                    value={formatFullHour(car?.optimization?.created_at)}
                />

            </Box>
            

            {/* Collapsed extra info */}
            <Collapse in={expandedCard === idx} timeout="auto" unmountOnExit>
              {/* <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap', mb: 2 }}> */}
              {/* <Box sx={{ display: 'flex', justifyContent: 'space-between',flexWrap: 'wrap', width: '100%', mb: 2, ml: 2 }}> */}
                <Box
                    sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(6, 1fr)', 
                    width: '100%',
                    gap: 2,
                    mb: 2,
                    ml:2,
                    '@media (max-width:1200px)': { gridTemplateColumns: 'repeat(3, 1fr)' },
                    '@media (max-width:800px)': { gridTemplateColumns: 'repeat(2, 1fr)' },
                    '@media (max-width:500px)': { gridTemplateColumns: 'repeat(1, 1fr)' },
                    }}
                >
                    <DataItem
                    label="Range"
                    value={
                        detailsdata?.[car.VIN]?.chargeState.range != null
                        ? `${parseInt(detailsdata?.[car.VIN]?.chargeState.range)} miles`
                        : '-'
                    }
                    />
                    <DataItem
                    label="Status"
                    value={capitalize(getPlugStateName(car.evstatus.Chargingstatus))}
                    />


                    <DataItem
                    label="Odometer"
                    value={
                        detailsdata?.[car.VIN]?.odometer != null
                        ? `${parseInt(detailsdata?.[car.VIN]?.odometer)} miles`
                        : '-'
                    }
                    />
                    <DataItem
                    label="Charge Limit"
                    value={
                        detailsdata?.[car.VIN]?.chargeState.chargeLimit != null
                        ? String(detailsdata?.[car.VIN]?.chargeState.chargeLimit)
                        : '-'
                    }
                    />
              </Box>

            {/* DUPLICATE ----- Pie + histogram section side-by-side */}
              <Box sx={{ display: 'flex', gap: 4, mt: 3, flexWrap: 'wrap' }}>
                {/* Pie chart */}
                {/* <Box sx={{ flex: 1, minWidth: 300 }}> */}
                <Box sx={{ flex: 1, minWidth: 300, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 600, textAlign: 'center', mt: 3 }}
                    >
                        SOC percentage change
                    </Typography>
                    <SessionsChartSmall
                        xAxisScaleType="time"
                        {...car.socCard}
                        key={'soc' + car.VIN}
                        xLabel="soc"
                        yLabel="state of charge %"
                    />
                </Box>

                {/* Histogram */}
                {/* <Box sx={{ flex: 1, minWidth: 300 }}> */}
                <Box sx={{ flex: 1, minWidth: 300, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 600, textAlign: 'center', mt: 3 }}
                    >
                        Change in power
                    </Typography>
                    <SessionsChartSmall
                        {...car.optimizationCard}
                        key={'o' + car.VIN}
                        xLabel="charge power [kW]"
                        xAxisScaleType="time"
                        yLabel="power [kW]"
                        referencelineLabel={`Max charge power: ${parseFloat(
                        car.maxOptimization?.toFixed(3)
                        )} kW`}
                        referenceLineY={car.maxOptimization}
                    />
                </Box>
              </Box>

              {/* Pie + histogram section side-by-side */}
              <Box sx={{ display: 'flex', gap: 4, mt: 3, flexWrap: 'wrap' }}>
                {/* Pie chart */}
                {/* <Box sx={{ flex: 1, minWidth: 300 }}> */}
                <Box sx={{ flex: 1, minWidth: 300, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, textAlign: 'center', mb: 1 }}
                  >
                    Percentage of time battery charge
                  </Typography>
                  <div id={`vehicle-piechart-${car.VIN}`} style={{ width: '100%' }}>
                    <CarPieChart
                      data={[
                        { name: '< 10%', value: Number(car.piedata.less_than_10) || 0 },
                        { name: '10-80%', value: Number(car.piedata.between_10_and_80) || 0 },
                        { name: '> 80%', value: Number(car.piedata.greater_than_80) || 0 },
                      ]}
                    />
                  </div>
                  {/* <Typography sx={{ color: 'text.secondary', textAlign: 'center' }}> */}
                    <Typography sx={{ color: 'text.secondary', textAlign: 'center', mt: 1 }}>
                    Keeping the battery between 10-80% <br /> helps the battery to last longer.
                  </Typography>
                </Box>

                {/* Histogram */}
                {/* <Box sx={{ flex: 1, minWidth: 300 }}> */}
                <Box sx={{ flex: 1, minWidth: 300, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, textAlign: 'center', mb: 1 }}
                  >
                    Battery State of Health
                  </Typography>
                <div id={`vehicle-histogram-${car.VIN}`} style={{ width: '60%' }}>

                  <Battery capacity={getCapacityByVIN(car.VIN)} soh={getSOHByVIN(car.VIN)} />
                  <HistogramChart
                    data={histogram1}
                    wearPosition={getBinIndexBySohAndVin(car.VIN)}
                    socValue={parseInt(evstatus?.[car.VIN]?.currentSoc || 0)}
                  />
                  <Typography sx={{ color: 'text.secondary', textAlign: 'center', mt: 1 }}>
                    Given the mileage this battery against comparable cars have :{' '}
                    {getWearCategoryByVIN(car.VIN)}
                  </Typography>
                </div>

                </Box>
              </Box>
                          
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => handlePrintVehicle(car.VIN)}
                >
                  Print Certificate
                </Button>
              </Box>
            </Collapse>

            {/* Expand toggle */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <IconButton
                onClick={() => toggleExpand(idx)}
                sx={{ width: 80, height: 20, padding: 0.5 }}
              >
                {expandedCard === idx ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </Box>
          </CardContent>
        </Card>
      ))}
    </Stack>

    {/* Pagination */}
    {carData.length > itemsPerPage && (
      <Pagination
        size="small"
        count={Math.ceil(carData.length / itemsPerPage)}
        page={page}
        onChange={handleChange}
        sx={{ display: 'flex', justifyContent: 'center', marginTop: 4 }}
      />
    )}
  </Box>
);

}


function DataItem({ label, value }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 120 }}>
      <Typography variant="subtitle2" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="subtitle2" fontWeight={550}>
        {value}
      </Typography>
    </Box>
  );
}
